import { routes } from "@constants/routes";
import { CertificateAndLicenseTable, CertificateForm, useResumeStore, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import { useGetCertificateAndLicenseByIdLazyQuery, useGetCertificateAndLicensesQuery } from "@graphql/generated";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

export type TCertificateAndLicenseState = "TABLE" | "FORM";

const CertificateTabContent = () => {
  const params = useParams();
  const location = useLocation();
  const [certificateAndLicenseState, setCertificateAndLicenseState] = useState<TCertificateAndLicenseState>("TABLE");
  const { data, refetch, loading } = useGetCertificateAndLicensesQuery({ variables: { id: params.id } });
  const { setCertificateAndLicenseEditId } = useResumeStore();
  const [
    getCertificateAndLicenseInfoById,
    { data: certificateAndLicenseInfo, loading: getCertificateAndLicenseInfoLoading },
  ] = useGetCertificateAndLicenseByIdLazyQuery();
  useEffect(() => {
    setCertificateAndLicenseEditId(undefined);
  }, [setCertificateAndLicenseEditId]);

  return (
    <div>
      {certificateAndLicenseState === "TABLE" ? (
        <CertificateAndLicenseTable
          setCertificateAndLicenseState={setCertificateAndLicenseState}
          certificateAndLicenseState={certificateAndLicenseState}
          handleNextTab={() => {}}
          data={data?.admin?.jobSeekers?.edges[0]?.node?.certificateandlicenses || []}
          refetch={refetch}
          loading={loading}
          showAddNewSection={false}
        />
      ) : (
        <CertificateForm
          setCertificateAndLicenseState={setCertificateAndLicenseState}
          pathname={location.pathname}
          supportUrl={routes.support.main}
          getCertificateInfoById={getCertificateAndLicenseInfoById}
          certificateInfo={certificateAndLicenseInfo?.admin?.certificateAndLicense}
          getCertificateInfoLoading={getCertificateAndLicenseInfoLoading}
          userType={UserTypeEnum.ADMIN}
        />
      )}
    </div>
  );
};

export default CertificateTabContent;
